import type { TourStep } from "@/components/GuidedTour";

export const influencersTourSteps: TourStep[] = [
  {
    target: "",
    title: "Influencer Marketing",
    titleAr: "تسويق المؤثرين",
    description: "Pair your DOOH campaign with Saudi creators. We'll show you how to discover, book, or join the roster.",
    descriptionAr: "اربط حملتك الإعلانية الخارجية بمبدعين سعوديين. سنريك كيف تكتشف، تحجز، أو تنضم إلى القائمة.",
  },
  {
    target: "inf-hero",
    title: "Discover Creators",
    titleAr: "اكتشف المبدعين",
    description: "Top influencers across Saudi Arabia, all verified through Mawthooq and ready to amplify your brand.",
    descriptionAr: "أبرز المؤثرين في المملكة، موثّقون عبر موثوق وجاهزون لتعزيز علامتك التجارية.",
  },
  {
    target: "inf-categories",
    title: "Browse by Category",
    titleAr: "تصفّح حسب الفئة",
    description: "Beauty, Lifestyle, Gaming, Travel, Food, and Entertainment — pick a niche that matches your audience.",
    descriptionAr: "الجمال، نمط الحياة، الألعاب، السفر، الطعام، والترفيه — اختر مجالاً يناسب جمهورك.",
  },
  {
    target: "inf-cta",
    title: "Book or Apply",
    titleAr: "احجز أو قدّم",
    description: "Brands: book a creator for your next push. Creators: apply to join — a 10% platform fee keeps the network premium.",
    descriptionAr: "للعلامات التجارية: احجز مبدعاً لحملتك القادمة. للمبدعين: قدّم للانضمام — رسوم منصة 10% تحافظ على جودة الشبكة.",
  },
];
